import { HandleType } from '@/enums/handle-type.enum';
import type { BaseNodeData, Handle } from '@/types/node';

/** Matches the canonical router template so WASM / UI agree on `in` / `out` handle ids. */
const ROUTER_INPUT_IN: Handle = {
  id: 'in',
  type: HandleType.Any,
  label: 'in',
  format: 'uri',
  order: 0,
  required: false,
  description: '',
};

const ROUTER_OUTPUT_OUT: Handle = {
  id: 'out',
  type: HandleType.Any,
  label: 'out',
  format: 'uri',
  order: 0,
  required: false,
  description: '',
};

/**
 * Ensures programmatically created routers match the palette shape (worked before `createNewNode` alone).
 */
export function mergeRouterNodeDataForInsert(data: BaseNodeData): BaseNodeData {
  return {
    ...data,
    version: 3,
    color: data.color ?? '#000000',
    description: data.description ?? '',
    type: 'router',
    name: data.name ?? 'Router',
    handles: {
      input: { in: ROUTER_INPUT_IN },
      output: { out: ROUTER_OUTPUT_OUT },
    },
  };
}
